import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconHelp = function IconHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.40234 9.46875C7.62744 6.26769 10.6792 4 14.25 4C17.8208 4 20.8726 6.26769 22.0977 9.46875",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8125,
    y: 22.125,
    width: 1.875,
    height: 3.20312,
    rx: 0.9375,
    transform: "rotate(90 16.8125 22.125)",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9.625,
    width: 5.125,
    height: 8.75,
    rx: 2.5625,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.375,
    y: 9.625,
    width: 5.125,
    height: 8.75,
    rx: 2.5625,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1399 22.406C16.7249 22.4512 16.4294 22.8185 16.4799 23.2263C16.5303 23.6342 16.9076 23.9282 17.3226 23.883L17.1399 22.406ZM20.2465 21.5561L20.845 22.0171L20.2465 21.5561ZM21.4638 18.3749C20.707 18.3819 20.707 18.3816 20.707 18.3814C20.707 18.3813 20.707 18.381 20.707 18.3808C20.707 18.3805 20.707 18.3802 20.707 18.3799C20.707 18.3793 20.707 18.3789 20.707 18.3785C20.707 18.3777 20.707 18.3773 20.707 18.3773C20.707 18.3773 20.707 18.3787 20.7069 18.3816C20.7069 18.3873 20.7068 18.3987 20.7062 18.4153C20.7051 18.4486 20.7024 18.5028 20.6957 18.5749C20.6821 18.7193 20.6526 18.9335 20.5883 19.1933C20.4597 19.7135 20.1944 20.4077 19.6479 21.095L20.845 22.0171C21.5487 21.1321 21.8922 20.2356 22.0596 19.5584C22.1434 19.2195 22.1838 18.9332 22.2031 18.7268C22.2128 18.6235 22.2173 18.5397 22.2193 18.4789C22.2203 18.4485 22.2207 18.4238 22.2208 18.4052C22.2208 18.3958 22.2208 18.3881 22.2207 18.3818C22.2207 18.3787 22.2207 18.376 22.2206 18.3737C22.2206 18.3725 22.2206 18.3715 22.2206 18.3705C22.2206 18.37 22.2206 18.3696 22.2206 18.3691C22.2206 18.3689 22.2206 18.3686 22.2206 18.3685C22.2206 18.3682 22.2205 18.3679 21.4638 18.3749ZM19.6479 21.095C19.2156 21.6387 18.6019 21.9724 18.0575 22.1707C17.7899 22.2682 17.5519 22.3283 17.3831 22.3635C17.299 22.3811 17.2332 22.3923 17.1908 22.3988C17.1696 22.4021 17.1543 22.4041 17.1456 22.4053C17.1412 22.4058 17.1385 22.4062 17.1375 22.4063C17.137 22.4064 17.137 22.4064 17.1374 22.4063C17.1376 22.4063 17.1379 22.4063 17.1383 22.4062C17.1385 22.4062 17.1387 22.4062 17.139 22.4061C17.1391 22.4061 17.1394 22.4061 17.1394 22.4061C17.1397 22.4061 17.1399 22.406 17.2313 23.1445C17.3226 23.883 17.3229 23.883 17.3231 23.883C17.3232 23.883 17.3235 23.883 17.3237 23.8829C17.3241 23.8829 17.3245 23.8828 17.3249 23.8828C17.3258 23.8827 17.3268 23.8826 17.3279 23.8825C17.3302 23.8822 17.3329 23.8819 17.3361 23.8815C17.3424 23.8807 17.3506 23.8797 17.3606 23.8784C17.3805 23.8758 17.4075 23.8721 17.4409 23.867C17.5076 23.8567 17.6002 23.8408 17.7132 23.8172C17.9383 23.7702 18.2484 23.6918 18.5975 23.5646C19.2865 23.3136 20.1804 22.8531 20.845 22.0171L19.6479 21.095Z",
    fill: "black"
  }));
};

export { IconHelp };